/**
 * The date line on the exported PDF cover.
 *
 * Lives here rather than in a component because two places start an export —
 * the report page and the interviews table — and they must produce the same
 * line for the same interview.
 */
import { format } from 'date-fns';
const at = (...candidates) => {
    const iso = candidates.find(Boolean);
    if (!iso)
        return null;
    const d = new Date(iso);
    return Number.isNaN(d.getTime()) ? null : format(d, 'PPP p');
};
/**
 * Each label promises a specific moment — a scheduled slot is not the same as
 * an actual start or completion — so the timestamp is chosen to match the word
 * in front of it rather than always using the scheduled `valid_from`.
 *
 * Returns null when the matching timestamp is missing or unparseable, so the
 * cover simply omits the row instead of printing "Invalid Date".
 */
export const interviewDateLabel = (interview, status) => {
    const iv = interview !== null && interview !== void 0 ? interview : {};
    switch ((status !== null && status !== void 0 ? status : '').toLowerCase()) {
        case 'scheduled': {
            const v = at(iv.valid_from);
            return v && `Scheduled On: ${v}`;
        }
        case 'in-progress': {
            const v = at(iv.started_at, iv.valid_from);
            return v && `Started On: ${v}`;
        }
        case 'completed':
        case 'pass':
        case 'fail': {
            const v = at(iv.ended_at, iv.started_at, iv.valid_from);
            return v && `Completed On: ${v}`;
        }
        case 'expired': {
            const v = at(iv.valid_from);
            return v && `Expired On: ${v}`;
        }
        default: {
            const v = at(iv.started_at, iv.valid_from);
            return v && `Interview Date: ${v}`;
        }
    }
};
